const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/Buttons/QuickLoginBtn.tsx';
import { useDispatch } from 'react-redux';
import Button from '@mui/material/Button';
import * as React from 'react';
import { actionDevLogin } from 'App/actions/fixme.login';
import { css } from '@emotion/css';

/**
 * React props
 */
export interface IQuickLoginBtnProps {
    disabled?: boolean;
}

const cssBtnStyle = css`
    text-align: start;
`;

/**
 * Functional React component
 */
export const QuickLoginBtn = (props: IQuickLoginBtnProps) => {
    const dispatch = useDispatch();

    const getQuickLoginTokenClickHandler = () => {
        dispatch(actionDevLogin());
    };
    return (
        <div>
            <Button
                variant="text"
                color="primary"
                disabled={props.disabled}
                onClick={getQuickLoginTokenClickHandler}
                className={cssBtnStyle}
            >
                {'Schnellanmeldung für Entwickler'}
            </Button>
        </div>
    );
};
